// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".def-price[data-v-d6b3cd8a]{font-size:1rem;font-weight:600;line-height:110%}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/Def/DefPrice/DefPrice.vue"],"names":[],"mappings":"AAAA,4BAAW,cAAA,CAAgC,eAAA,CAAjB,gBAI1B","sourcesContent":[".def-price{font-size:1rem;line-height:110%;font-weight:600}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
